export default __webpack_public_path__ + "8ed125d0c0ee8745ce66ca77f0b20777.webp";